const fetchConversationReducer = (state, action) => {
  if (action.status !== 'success') return state;

  const {
    payload: { conversationId, conversation },
  } = action;

  const conversationFromState = state.conversations[conversationId] || {};

  const newConversations = {
    ...state.conversations,
    [conversationId]: {
      messages: [],
      ...conversationFromState,
      ...conversation,
    },
  };

  return {
    ...state,
    conversations: newConversations,
  };
};

export default fetchConversationReducer;
